import React from 'react';
import interns from '../../assets/interns.jpg'
import youngpeople from '../../assets/young-people.jpg'
export const Feature10DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children: interns,
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>Internship Programs</p>
            </span>
          </span>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <span>
          <span>
            <span>
              <span>
                <p>
                  Impactful leadership are what brings breakthroughs and success
                  to organizations. Our team shortlists only the best and proven
                  leaders with domain expertise that are a perfect match for
                  your organization.&nbsp;
                </p>
              </span>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
export const Feature20DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
  img: {
    children: 'data:image/png;base64,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',
  },
  textWrapper: { className: 'content2-text', md: 14, xs: 24 },
  title: {
    className: 'content2-title',
    children: (
      <span>
        <p>GetJobs</p>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <span>
          <p>
            GetJobs is Singapore's premier part-timers platform. It is an end-end platform that allows part-timers apply, get offered, clock-in, and get paid in an all-in-one mobile platform. {' '}
          </p>
        </span>
      </span>
    ),
  },
};
export const Feature11DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children: youngpeople,
  },
  textWrapper: { className: 'content1-text', md: 14, xs: 24 },
  title: {
    className: 'content1-title',
    children: (
      <span>
        <p>Outsourcing</p>
      </span>
    ),
  },
  content: {
    className: 'content1-content',
    children: (
      <span>
        <span>
          <p>
            In highly demanding business environments, companies are adopting outsourced manpower to achieve agility and increased profitability. In order to better focus on their core business competencies and growth markets, companies look to us to manage their day to day payroll functions and contract positions. We ensure strict regulatory compliance at every level so that your employees benefirs and entitlements are not compromised in any way.{' '}
          </p>
          {/* <ul>
            <li>Payroll System, CPF registration, Corp Pass Administrator set up</li>
            <li>Monthly payroll processing and reports</li>
            <li>Mandatory CPF, CDAC, MBMF, SINDA, SDL contributions</li>
            <li>Annual IR8A statements</li>
            <li>Tax Clearance for foreign employees</li >
            <li>Annual and Medical Leave administration</li >
            <li>Expenses Claim and Ad - hoc payments</li >
          </ul> */}
        </span>
      </span>
    ),
  },
};
